import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';

const { CREATE_SCREENING_REQUEST, CREATE_SCREENING_SUCCESS, CREATE_SCREENING_FAILURE } =
  screeningAction;

function* createScreeningRecord(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(screeningService.createScreening, payload?.payload);
    if (response?.status === 201) {
      yield put({ type: CREATE_SCREENING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_SCREENING_FAILURE, payload: error });
  }
}

function* createScreeningSaga() {
  yield takeEvery(CREATE_SCREENING_REQUEST, createScreeningRecord);
}

export default createScreeningSaga;
